import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private storeId: object = {};

  private profileImageSource = new BehaviorSubject<string | null>(null);
  profileImage$ = this.profileImageSource.asObservable();

  // ✅ BehaviorSubjects initialized with sessionStorage (if available)
  private projectNameSource = new BehaviorSubject<string | null>(
    sessionStorage.getItem('projectName')
  );
  private companyNameSource = new BehaviorSubject<string | null>(
    sessionStorage.getItem('companyName')
  );

  projectName$ = this.projectNameSource.asObservable();
  companyName$ = this.companyNameSource.asObservable();

  constructor(private router: Router) {}

  /**
   * ✅ Update and store project & company name
   * This will automatically update subscribers (like PublicLayoutComponent)
   */
  updateProjectCompany(project: string, company: string) {
    sessionStorage.setItem('projectName', project);
    sessionStorage.setItem('companyName', company);
    this.projectNameSource.next(project);
    this.companyNameSource.next(company);
  }

  // Store/retrieve any object globally
  setDeviceData(val: object) {
    this.storeId = val;
  }
  getDeviceData() {
    return this.storeId;
  }

  // Update profile image dynamically
  updateProfileImage(imageSrc: string | null) {
    this.profileImageSource.next(imageSrc);
  }

  // Generate a random password
  generatePass(passwordLength = 16): string {
    const lowerCaseLetters = 'abcdefghijklmnopqrstuvwxyz';
    const upperCaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const symbols = '!@#$%^&*()_-,.';
    const characters = lowerCaseLetters + upperCaseLetters + numbers + symbols;

    const generatedPassword = [];
    for (let i = 0; i < passwordLength; i++) {
      const idx = Math.floor(Math.random() * characters.length);
      generatedPassword.push(characters[idx]);
    }
    return generatedPassword.join('');
  }

  // ACL check helpers
  getActionItem(actionName: string) {
    const list = JSON.parse(localStorage.getItem('aclDataCCSMOBI') as string);
    const subList = list.flatMap((item: any) => item.submenu);
    const url = this.router.url.trim();
    let subUrl = url.substring(url.indexOf('/', 1));
    if (subUrl.includes('?')) subUrl = subUrl.split('?')[0];
    const subMenu = subList.find((sub: any) => sub.url === subUrl);
    return !!subMenu?.action.find((act: any) => act.name === actionName);
  }

  getActionItemBySubmenu(submenuName: string, actionName: string) {
    const list = JSON.parse(localStorage.getItem('aclDataCCSMOBI') as string);
    const subList = list.flatMap((item: any) => item.submenu);
    const subMenu = subList.find((sub: any) => sub.name === submenuName);
    return !!subMenu?.action.find((act: any) => act.name === actionName);
  }

  // Helper: list of months
  getMonths() {
    return [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sept',
      'Oct',
      'Nov',
      'Dec',
    ];
  }

  DATE_FORMAT: string = 'DD/MM/YYYY';

  formatDate(date: Date) {
    try {
      const m = moment(date);
      return m.isValid() ? m.format(this.DATE_FORMAT) : '';
    } catch {
      return '';
    }
  }
}
